export default {
  success: {
    color: '#E8F5E9',
    textColor: '#66BB6A',
  },
  danger: {
    color: '#FFCDD2',
    textColor: '#E53935',
  },
  warning: {
    color: '#FFF9C4',
    textColor: '#F57F17',
  },
  neutral: {
    color: '#ECEFF1',
    textColor: '#78909C',
  },
  light: {
    color: '#E1F5FE',
    textColor: '#80D8FF',
  },
  wait: {
    color: '#FFF3E0',
    textColor: '#FFA726',
  },
};
